"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoursePricing = void 0;
const getActiveContracts_1 = require("./getActiveContracts");
const dayjs = require("dayjs");
const getCoursePricing = (date, contracts) => {
    // get the active golf contract
    const activeContracts = (0, getActiveContracts_1.getActiveContracts)(date, contracts);
    const selected_date = date || dayjs().add(3, "day").format("YYYY-MM-DD");
    const futureContracts = activeContracts.filter((contract) => {
        const contractDate = new Date(contract.start_date);
        const currentDate = dayjs(selected_date, "YYYY-MM-DD").toDate();
        return contractDate.getTime() > currentDate.getTime();
    });
    const currentContracts = activeContracts
        .filter((contract) => {
        const contractStartDate = new Date(contract.start_date);
        const contractEndDate = new Date(contract.end_date);
        const currentDate = dayjs(selected_date, "YYYY-MM-DD").toDate();
        return (contractStartDate.getTime() <= currentDate.getTime() &&
            contractEndDate.getTime() >= currentDate.getTime());
    })
        .sort((a, b) => {
        // sort by contracts on promotion first
        if (a.type === "PROMOTIONAL_RATE" && b.type !== "PROMOTIONAL_RATE")
            return -1;
        if (a.type !== "PROMOTIONAL_RATE" && b.type === "PROMOTIONAL_RATE")
            return 1;
        return 0;
    });
    // if there are no current contracts, get the first future contract
    let contract = currentContracts[0] || futureContracts[0];
    if (!contract)
        return {
            price: 0,
        };
    contract = contract;
    // get the cheapest rate in the contract
    // go through each product in the contract and then each rate in the product to find the cheapest rate
    let cheapestRate = {
        price: 0,
        reference_rate: 0,
        currency: "",
        product: "",
        valid_from: "",
        valid_to: "",
    };
    contract.products?.forEach((golf_product) => {
        if (golf_product.product.config.holes === "18") {
            golf_product.rates?.forEach((rate) => {
                if (cheapestRate.price === 0 || rate.sell_price < cheapestRate.price) {
                    cheapestRate = {
                        valid_from: contract.start_date,
                        valid_to: contract.end_date,
                        price: rate.sell_price,
                        reference_rate: rate.reference_rate,
                        currency: contract.currency_code,
                        product: golf_product.product.name.en,
                    };
                }
            });
        }
    });
    return cheapestRate;
};
exports.getCoursePricing = getCoursePricing;
